import React, { Component } from 'react'
import { Container, Row, Col, Jumbotron, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import ClockIcon from 'react-icons/lib/fa/clock-o'
import TagIcon from 'react-icons/lib/fa/tag'
import OpenIcon from 'react-icons/lib/fa/folder-open'
// import PostIcons from '../components/PostIcons'

// import { rhythm } from '../utils/typography'

import Hero from '../components/About/Hero'
import Team from '../components/About/Team'
import AboutContent from '../components/About/About_Content';


class About extends Component {
  render() {

    console.log('props.data', this.props.data);

    return (
      <div className="about">
        <Hero heroImage={this.props.data.heroImage} />

        <AboutContent />

        <Team />
        
      </div>
    )
  }
}

export default About

export const pageQuery = graphql`
  query aboutPageQuery {
    heroImage: imageSharp(id: { regex: "/about-hero/" }) {
      sizes(maxWidth: 1240 ) {
        ...GatsbyImageSharpSizes
      }
      resolutions {
        ...GatsbyImageSharpResolutions
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.jsx